<template>
    <div>
        <myHeader></myHeader>
        <aboutNav></aboutNav>
        <div class="job_wrap">
            <div class="job">
                <div class="job_li" v-for="(item,index) in job_list" :key="index">
                    <div class="job_li_title">{{item.job_name}}</div>
                    <div class="job_li_tips">
                        <div class="tips_li">
                            <img src="../../../static/images/job_lingdai.png" alt="">
                            <span>{{item.job_year}}</span>
                        </div>
                        <div class="tips_li">
                            <img src="../../../static/images/job_ren.png" alt="">
                            <span>{{item.job_nums}}</span>
                        </div>
                        <div class="tips_li">
                            <img src="../../../static/images/job_time.png" alt="">
                            <span>{{item.date}}</span>
                        </div>
                    </div>
                    <div class="job_text">
                        <div class="job_text_title">任职要求：</div>
                        <div class="job_text_nr" v-html="item.job_require">
                        </div>
                        <div class="job_text_title">岗位职责：</div>
                        <div class="job_text_nr" v-html="item.job_content">
                        </div>
                    </div>
                </div>
                <el-empty :image-size="160" v-show="job_list.length === 0"></el-empty>
            </div>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../../components/header.vue'
import MyFooter from '../../components/footer.vue'
import aboutNav from '../../components/about_nav.vue'
export default {
    name: 'about_job',
    components: {MyFooter, myHeader,aboutNav},
    data () {
        return {
            job_list:[]
        }
    },
    created () {
        this.pageData();
    },
    methods: {
        pageData () {
            this.$api.jobList().then(res => {
                this.job_list = res.data;
                console.log(this.job_list.length)
            });
        },
    }
}
</script>

<style scoped>
.job_wrap{width:100%;height:auto;float:left;}
.job{width:1200px;height:auto;float:left;min-height:400px;position:relative;left:50%;margin-left:-600px;}
.job_li{padding:40px 0 50px;border-bottom:1px solid #ddd;float:left;width:100%;height:auto;}
.job_li_title{width:100%;height:40px;font-size:20px;color:#0a64ba;line-height:40px;display:block;float:left;font-weight:bold;letter-spacing:2px;}
.job_li_tips{width:100%;height:25px;display:block;float:left;margin-top:15px;padding-bottom:5px;}
.job_li_tips .tips_li{width:auto;height:20px;display:inline-block;float:left;margin-left:50px;}
.job_li_tips .tips_li:first-child{margin-left:0;}
.tips_li img{height:16px;width:auto;display:inline-block;float:left;margin:2px 0;vertical-align:top;}
.tips_li span{width:auto;height:20px;font-size:14px;color:#333;line-height:22px;display:inline-block;margin-left:6px;vertical-align:top;}
.job_text{width:100%;height:auto;float:left;}
.job_text_title{width:100%;height:20px;font-size:16px;display:block;float:left;font-weight:bold;margin-top:15px;}
.job_text_nr{width:100%;height:auto;font-size:14px;color:#333;line-height:24px;display:block;float:left;margin-top:10px;}
.job .job_li:last-child{border-color:#fff;}
@media (min-width:992px) and (max-width:1200px){
    .job{width:1000px;min-height:300px;margin-left:-500px;}
    .job_li{padding:30px 0 40px;}
    .job_li_title{height:36px;font-size:18px;line-height:36px;}
    .job_li_tips{height:25px;margin-top:10px;padding-bottom:5px;}
    .job_li_tips .tips_li{height:20px;margin-left:50px;}
    .tips_li img{height:16px;margin:2px 0;vertical-align:top;}
    .tips_li span{height:20px;font-size:14px;line-height:22px;margin-left:6px;}
    .job_text_title{height:20px;font-size:15px;margin-top:15px;}
    .job_text_nr{font-size:13px;line-height:20px;margin-top:10px;}
}
@media (min-width:768px) and (max-width:991px){
    .job{width:750px;min-height:200px;margin-left:-375px;}
    .job_li{padding:20px 0 30px;}
    .job_li_title{height:36px;font-size:18px;line-height:36px;}
    .job_li_tips{height:25px;margin-top:10px;padding-bottom:5px;}
    .job_li_tips .tips_li{height:20px;margin-left:50px;}
    .tips_li img{height:16px;margin:2px 0;vertical-align:top;}
    .tips_li span{height:20px;font-size:14px;line-height:22px;margin-left:6px;}
    .job_text_title{height:20px;font-size:15px;margin-top:15px;}
    .job_text_nr{font-size:13px;line-height:20px;margin-top:10px;}
}
@media (max-width:767px){
    .job{width:100%;min-height:200px;margin-left:0;left:0;}
    .job_li{padding:10px 15px 20px;}
    .job_li_title{height:36px;font-size:18px;line-height:36px;}
    .job_li_tips{height:25px;margin-top:10px;padding-bottom:5px;}
    .job_li_tips .tips_li{height:20px;margin-left:30px;}
    .tips_li img{height:16px;margin:2px 0;vertical-align:top;}
    .tips_li span{height:20px;font-size:12px;line-height:20px;margin-left:5px;}
    .job_text_title{height:20px;font-size:15px;margin-top:15px;}
    .job_text_nr{font-size:13px;line-height:20px;margin-top:10px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about_job.vue